import moment from "moment-timezone";

export const DataFilterTypes ={
  NoiseReduction: 0,
  Focus: 1,
  FocusByPercentage: 2,
  NoiseReductionStep: 3,
  FocusRemoveWorst: 4,
  // 5 was FocusVectorRemoveWorst, removed 2026-08-14 (broken projection math).
  // Do not reuse 5: these values are persisted as bare ints in every scan blob.
  NoiseReductionScatter: 6,
}

export const roundToX = (num, decimals) => {
    decimals = (decimals) ? decimals : 0;
    let rounded = 0;
    if(num.toString().indexOf('e') !== -1) {
      rounded = 0; // the number of is so small; display zero
    } else {
      rounded = +(Math.round(num + "e" + decimals) + "e-" + decimals);
    }
    console.log(`num: ${num}; decimals: ${decimals} rounded: ${rounded}`);
    return rounded;
}

export const median = (arr) => {
    if (arr.length === 0) {
      return 0;
    }
    arr.sort((a, b) => a - b); // 1.
    const midpoint = Math.floor(arr.length / 2); // 2.
    const median = arr.length % 2 === 1 ?
      arr[midpoint] : // 3.1. If odd length, just take midpoint
      (arr[midpoint - 1] + arr[midpoint]) / 2; // 3.2. If even length, take median of midpoints
    return median;
}

export const pad = (num, size) => {
  num = num.toString();
  while (num.length < size) num = "0" + num;
  return num;
}

export const hashCode = (str) => {
  let hash = 0;
  for (let i = 0, len = str.length; i < len; i++) {
      let chr = str.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

export const formatDateTime = (dateTimeString, shortDate=false, dateOnly=false, timeZone="") => {

  if(timeZone.length === 0) {
      timeZone = moment.tz.guess(true);
  }
  
  let dateTimeFormat = "M/DD/YYYY h:mm a"; // date and time

  if(shortDate) {
      dateTimeFormat = "M/DD h:mm a";
  }

  if(shortDate && dateOnly) {
      dateTimeFormat = "M/DD";
  }

  return moment.tz(dateTimeString, timeZone).format(dateTimeFormat);
}

export const pointsStdDev = (points) => {
  const n = points.length;
  const mean = {y: 0, z: 0};

  for(let i=0;i<points.length;i++) {
    mean.y += points[i].y;
    mean.z += points[i].z;
  }
  mean.y = mean.y/n;
  mean.z = mean.z/n;

  let pow = points.map(p => {
    return {
      y: Math.pow(p.y - mean.y, 2),
      z: Math.pow(p.z - mean.z, 2)
    }
  });

  let stdDev = {y:0,z:0};
  for(let i=0;i<pow.length;i++){
    stdDev.y += pow[i].y;
    stdDev.z += pow[i].z;
  }
  
  stdDev.y = Math.sqrt(stdDev.y / n);
  stdDev.z = Math.sqrt(stdDev.z / n);

  return stdDev;
}

export const pointsRSquared = (points, average, slope, intercept) => {
  let ssr = {
    y: 0,
    z: 0,
  }; // sum square regression
  let sst = {
    y: 0,
    z: 0,
  }; // total sum of squares

  for(let i=0;i<points.length;i++){
    ssr.y += Math.pow(points[i].y - (points[i].x * slope.pitch.value + intercept.YIntercept.value), 2);
    sst.y += Math.pow(points[i].y - average.y, 2);
    ssr.z += Math.pow(points[i].z - (points[i].x * slope.yaw.value + intercept.ZIntercept.value), 2);
    sst.z += Math.pow(points[i].z - average.z, 2);
  }

  return {
    y: (1 - (ssr.y/sst.y)),
    z: (1 - (ssr.z/sst.z))
  };
}

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/* const sumPoints = (a, b, fieldName) => {
  // a is an object in the first iteration then an accumulator value in all subsequent iterations
  let accumulator = (isNaN(a) ? a[fieldName] : a);
  accumulator += b[fieldName];
  return accumulator;
} */

/* export const standardDeviation = (points, fieldName) => {
  const n = points.length;
  const mean = points.reduce((a, b) => sumPoints(a,b,fieldName)) / n;
  console.log(`mean ${fieldName}: ${mean}`);
  let pow = points.map(p => Math.pow(p[fieldName] - mean, 2));
  console.log(`pow ${fieldName} count: ${pow.length}`);
  let sumPow = pow.reduce((a, b) => a + b);
  console.log(`sum pow - ${fieldName}: ${sumPow}`);
  return Math.sqrt(sumPow / n);
} */
/*
tempSSR = meas.yLoc - (meas.xLoc * slope_yloc + yIntyloc);
                      ssryloc += tempSSR * tempSSR;
                      tempSST = meas.yLoc - avgYyloc;
                      sstyloc += tempSST * tempSST;
*/